// extracted by mini-css-extract-plugin
export default {"container":"Main_container__GHAnH","wrapper":"Main_wrapper__Pc46j","mainContent":"Main_mainContent__UT4g6","dynamicContent":"Main_dynamicContent__y1Qa+"};